export default __webpack_public_path__ + "static/media/horse-slide1.9b785603.png";